export const routes = [
  {
      path: '/contact',
      name: 'Contacts',
      component: () => import ('@/views/contact/page.vue')
    }
]
